// extracted by mini-css-extract-plugin
module.exports = {"head":"thrd_head__yYMwI","tags":"thrd_tags__hHj2C"};